import axios from './axios'

/**
 * @description 获取登录的用户名和密码
 * @param {Object} data 内容
 */
export const WebIMLogin = (data) => {
  const api = `/im/createChat`;
  return axios.post(api,data).then(res => res.data)
}

/**
 * @description 发送消息
 * @param {Object} data 内容
 */
export const WebIMSend = (data) => {
  const api = `/im/sendMsg`;
  return axios.post(api,data).then(res => res.data)
}

/**
 * @description 获取历史信息
 * @param {Object} data 内容
 */
export const WebHistory = (data) => {
  const api = `/im/getHistoryMsg`;
  return axios.post(api, data).then(res => res.data)
}

/**
 * @description 更新已读消息
 * @param {Object} data 内容
 */
export const WebUpdateMessage = (data) => {
  const api = `/im/updImUserInfo`;
  return axios.post(api, data).then(res => res.data)
}

/**
 * @description 获取用户信息
 * @param {Object} data 内容
 */
export const WebRent = (data) => {
  const api = `/im/getImUserInfo`;
  return axios.post(api, data).then(res => res.data)
}



// WEBPACK FOOTER //
// ./src/api/WebIM.js